import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import locale from 'antd/lib/date-picker/locale/fr_FR';

const dateFormat = 'DD/MM/YYYY';

export default class Date extends Component {
  static propTypes = {
    label: PropTypes.string,
    path: PropTypes.array.isRequired,
    form: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object,
    disabled: PropTypes.bool
  }

  render() {
    const { label, path, form, style, className, disabled, explain } = this.props
    const value = form.getValue(path)
    const handleChange = d => form.handleChange(path, d)
    const error = form.getError(path)
    const handleTouched = _ => form.handleTouched(path)
    return (
      <div className={"ant-form-item " + (className || '')} style={style}>
        <div className="ant-form-item-label">
          <label>{label}</label>
        </div>
        <div className={'ant-form-item-control ' + (error ? 'has-error' : '')}>
          <span className="ant-form-item-children">
            <DatePicker
              locale={locale}
              format={dateFormat}
              size="large"
              style={{width: '100%'}}
              value={value}
              onChange={handleChange}
              onBlur={handleTouched}
              onKeyUp={e => e.key === 'Enter' && handleTouched()}
            />
          </span>
          {error && (
            <div className="ant-form-explain">{error}</div>
          )}
          {!error && explain && (
            <div class="ant-form-explain">{explain}</div>
          )}
        </div>
      </div>
    )
  }
}
